import { OutboundLink } from 'gatsby-plugin-gtag';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  OutboundLink,
  BreadCrumbs,
  SEOHelmet,
  React
};